import { DocumentWorkspace } from '@/pages/documents/DocumentWorkspace';
import { AttachmentLabelsBar } from '@/components/custom/attachment-labels-bar';

interface DocumentTabContentProps {
  documentId: string;
  attachmentId: string;
  attachmentLabels: string[];
  classificationConfidence?: number | null;
  classificationMethod?: string | null;
  classificationReason?: string | null;
  disabled?: boolean;
}

/**
 * Task-side view of an extraction. Wraps the shared
 * `DocumentWorkspace` and adds the AttachmentLabelsBar above
 * the form — the only thing this surface needs that the standalone
 * detail page doesn't. Everything below the toolbar lives in the
 * workspace component, shared with `DocumentDetailPage`.
 */
export function DocumentTabContent({
  documentId,
  attachmentId,
  attachmentLabels,
  classificationConfidence,
  classificationMethod,
  classificationReason,
  disabled,
}: DocumentTabContentProps): React.ReactElement {
  return (
    <DocumentWorkspace
      documentId={documentId}
      attachmentLabels={attachmentLabels}
      rightPaneAccessory={
        <AttachmentLabelsBar
          attachmentId={attachmentId}
          labels={attachmentLabels}
          classificationConfidence={classificationConfidence}
          classificationMethod={classificationMethod}
          classificationReason={classificationReason}
          disabled={disabled}
        />
      }
    />
  );
}
